import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/store';

Vue.use(Router);

const Register = () => import('@/components/register/register');
const Profile = () => import('@/components/profile/profile');
const TesterLanding = () => import('@/components/tester/tester-landing');
const DbLanding = () => import('@/components/dashboard/db-landing');
const DbRequests = () => import('@/components/dashboard/db-requests');
const DbNdas = () => import('@/components/dashboard/db-ndas');
const DbEvents = () => import('@/components/dashboard/db-events');
const DbEvent = () => import('@/components/dashboard/db-event');
const ReportLanding = () => import('@/components/report/report-landing');
const Reports = () => import('@/components/report/reports');
const Error403 = () => import('@/components/errors/403-forbidden');
const Error404 = () => import('@/components/errors/404-not-found');

const r = new Router({
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',

  routes: [
    {
      path: '/',
      redirect: {name: 'register'},
      meta: {
        title: 'CRT',
      },
    },
    {
      path: '/register/:product?/:test?/:eventId?',
      name: 'register',
      component: Register,
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
    },
    {
      path: '/testers/:webkeyId?/:soldtoId?',
      name: 'testers',
      component: TesterLanding,
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: DbLanding,
      children: [
        {
          path: 'requests',
          name: 'requests',
          component: DbRequests,
        },
        {
          path: 'ndas',
          name: 'ndas',
          component: DbNdas,
                }, {
                    path: 'events',
                    name: 'events',
                    component: DbEvents,
                    children: [{
                        path: ':eventId',
                        name: 'event',
                        component: DbEvent,
                    }]
        },
      ],
    },
    {
      path: '/reports',
      name: 'reports',
      component: ReportLanding,
      children: [
        {
          path: ':productId',
          name: 'report',
          component: Reports,
        },
      ],
    },
    {
      path: '/error/403',
      name: '403',
      component: Error403,
    },
    {
      path: '/error/404',
      name: '404',
      component: Error404,
    },
    {
      path: '*',
      component: Error404,
    },
  ],
});

r.beforeEach((to, from, next) => {
    store.commit('reset');
    next();
});

export default r;
